import { UseCase } from './UseCase';
import { Sound } from '../entities/sound';
import { SupportedSound } from '../entities/SoundType';
export class NavigateUseCase extends UseCase {
    constructor(applicationServices) {
        super();
        this.applicationServices = applicationServices;
    }
    execute(event) {
        return Promise.resolve([
            this.applicationServices.interface.changeView(event.targetView),
            this.applicationServices.interface.playSound(new Sound(SupportedSound.POUFFF))
        ])
            .then(results => Promise.resolve())
            .catch(error => Promise.reject(error));
    }
}
